import {animate, style, transition, trigger} from '@angular/animations';

export const toggleSlideRight = trigger('toggleSlideRight', [
  transition(':enter', [
    style({
      transform: 'translateX(100%)',
      position: 'absolute',
      width: '100%',
      opacity: 0
    }),
    animate(
      '.6s cubic-bezier(.16,.78,.26,.99)',
      style({
        transform: 'translateX(0)',
        opacity: 1
      }),
    ),
  ]),
  transition(':leave', [
    style({
      transform: 'translateX(0)',
      position: 'absolute',
      width: '100%',
      opacity: 1
    }),
    animate(
      '.6s cubic-bezier(.16,.78,.26,.99)',
      style({
        transform: 'translateX(100%)',
        opacity: 0
      }),
    ),
  ]),
]);
